import React from 'react'
import faild from "../../assets/images/FailedAge.svg"
import { Link } from 'react-router-dom'
const ScanFaild = () => {
    return (
        <div className='faild'>
            <img src={faild} alt="" />
            <div className="BTNS">
                <Link to="#" style={{ fontSize:"12px"}}>Please try again with the new product QR Code</Link>
         
            </div>
        </div>
    )
}

export default ScanFaild